import { cn } from '@/utils/cn';
import { TYPE } from '@/lib/typography';

export function UnreadBadge({
  count,
  className,
}: {
  count: number;
  className?: string;
}) {
  if (count <= 0) return null;
  return (
    <span
      className={cn(
        TYPE.meta,
        'inline-flex h-5 min-w-[22px] items-center justify-center rounded-full bg-ds-coral-badge px-s1 text-white tabular-nums',
        className,
      )}
    >
      {count}
    </span>
  );
}
